import request from '../../../shared/request'

export function getJobFollowUps(job_id) {
  return request(`/job/follow_ups/${job_id}/`)
}

export function getRelatedEntity(followUpId) {
  return request(`/job/follow_ups/${followUpId}/related_entity`)
}

export function getJobFollowUpActivities(follow_up_id) {
  return request(`/job/activities/follow_up/${follow_up_id}/`)
}

export function createJobFollowUp(payload) {
  return request(`/job/follow_ups/${payload.job_follow_up_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobFollowUp(payload) {
  return request(`/job/follow_ups/${payload.job_follow_up_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobFollowUp(payload) {
  return request(`/job/follow_ups/${payload.job_follow_up_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/followUps.js